import { Flex, Text } from '@backstage/ui';
import { MarkdownContent } from '@backstage/core-components';

import { McpTool } from './mcpTypes';
import styles from './McpServerToolsCard.module.css';

export const ToolRow = ({ tool }: { tool: McpTool }) => (
  <div className={styles.tool}>
    <Flex direction="column" gap="1">
      <Text variant="title-small">{tool.name}</Text>
      {tool.description && (
        <div className={styles.description}>
          <MarkdownContent content={tool.description} />
        </div>
      )}
    </Flex>
  </div>
);
